import { render, staticRenderFns } from "./Display.vue?vue&type=template&id=06626d81"
import script from "./Display.vue?vue&type=script&lang=js"
export * from "./Display.vue?vue&type=script&lang=js"
import style0 from "./queue.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports